// extracted by mini-css-extract-plugin
export var headerCell = "_40-1";
export var loadingSpinnerContainer = "_40-4";
export var rowWrapper = "_40-3";
export var table = "_40-0";
export var white = "_40-2";